<div class="container-fluid">
  <div class="row g-4">
    <div class="col-12">
      <mat-card>
        <mat-card-content>

          <!-- Top Buttons -->
          <div *ngIf="isResultList">
            <button mat-flat-button color="primary" (click)="addResult()">
              Add Result
            </button>

            <button mat-flat-button color="primary" (click)="downloadResultList()">
              Download Full List
            </button>
          </div>

          <!-- Form Section -->
          <div *ngIf="!isResultList || isEdit">
            <form [formGroup]="formGroup">

              <div class="row g-4 mt-3">
                <div class="col-12">
                  <h6 class="section-title">Result Classification</h6>
                </div>

                <!-- Result Name -->
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Result Name</mat-label>
                    <input matInput formControlName="result_name" placeholder="Enter result name" />
                    <mat-error *ngIf="formGroup.get('result_name')?.errors?.['required']">
                      Result name is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Min Percentage -->
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Min Percentage</mat-label>
                    <input matInput type="number" formControlName="min_percentage" placeholder="e.g. 60" />
                    <mat-error *ngIf="formGroup.get('min_percentage')?.errors?.['required']">
                      Min percentage is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Max Percentage -->
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Max Percentage</mat-label>
                    <input matInput type="number" formControlName="max_percentage" placeholder="e.g. 70" />
                    <mat-error *ngIf="formGroup.get('max_percentage')?.errors?.['required']">
                      Max percentage is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Description -->
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Description</mat-label>
                    <input matInput formControlName="description" placeholder="Optional" />
                  </mat-form-field>
                </div>

              </div>

              <!-- Buttons -->
              <div class="row mt-4">
                <div class="col-12">
                  <div class="d-flex gap-3">
                    <button mat-flat-button color="primary" [disabled]="isLoading" (click)="saveResult()" class="px-4 py-2">
                      {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                    <button mat-stroked-button [disabled]="isLoading" (click)="resetForm()" class="px-4 py-2">
                      RESET
                    </button>
                    <button *ngIf="isEdit || !isResultList" mat-flat-button color="primary" (click)="back()" class="px-4 py-2">
                      Back
                    </button>
                  </div>
                </div>
              </div>

            </form>
          </div>

        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<!-- Result Master Table -->
<div *ngIf="isResultList">
  <div class="sorting-table">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <!-- Dynamic Columns -->
      <ng-container *ngFor="let column of displayedColumns.cols; let i = index" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ displayedColumns.label[i] | uppercase }}
        </th>
        <td mat-cell *matCellDef="let row; let rowIndex = index">
          <ng-container *ngIf="column === 'sno'; else otherCols">
            {{ currentPage + (rowIndex + 1) }}
          </ng-container>
          <ng-template #otherCols>
            {{ row[column] }}
          </ng-template>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="edit(row)">
              <mat-icon>edit</mat-icon> Edit
            </button>
            <button mat-menu-item (click)="delete(row)">
              <mat-icon>delete</mat-icon> Delete
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns.cols.concat(['actions'])"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns.cols.concat(['actions'])"></tr>

    </table>
  </div>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 15, 20]"
    [length]="pagination.length"
    [pageIndex]="pagination.page - 1"
    [pageSize]="pagination.limit"
    (page)="pageEvent($event)"
    *ngIf="pagination.length">
  </mat-paginator>
</div>
